module.exports = __webpack_public_path__ + "img/vm1-pro.9c7886c9.jpg";